export const graphqlConfig = {
  url: process.env.REACT_APP_HASURA_URL || ''
}
